import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UserAccount, UserAccountZelis } from '@rivethealth/data/user-account';
import { map } from 'rxjs/operators';
import { API_URL, ROUTER_API_URL } from './common';
import { PermissionLevel } from './user.service';

@Injectable({ providedIn: 'root' })
export class RouterUserAccountService {
  constructor(
    @Inject(ROUTER_API_URL) private readonly routerApiUrl: string,
    private readonly http: HttpClient,
  ) {}

  getAccountsByUser(userId: number) {
    return this.http.get<UserAccount[]>(`${this.routerApiUrl}/userAccounts`, {
      params: {
        userId: userId.toString(),
      },
    });
  }
}

@Injectable({ providedIn: 'root' })
export class UserAccountService {
  constructor(
    @Inject(API_URL) private readonly apiUrl: string,
    @Inject(ROUTER_API_URL) private readonly routerApiUrl: string,
    private readonly http: HttpClient,
  ) {}

  getAccountsByUser(userId: number) {
    return this.http.get<UserAccount[]>(`${this.routerApiUrl}/userAccounts`, {
      params: {
        userId: userId.toString(),
      },
    });
  }

  getZelisAccountsByUser(userId: number) {
    return this.http.get<UserAccountZelis[]>(
      `${this.routerApiUrl}/userAccounts/zelis`,
      {
        params: {
          userId: userId.toString(),
        },
      },
    );
  }

  addUserToAccount(
    email: string,
    accountId: number,
    permissionLevel: PermissionLevel,
  ) {
    return this.http.post(`${this.apiUrl}/userAccounts`, {
      email,
      accountId,
      permissionLevel,
    });
  }

  deleteUserAccount(userId: number, accountId: number) {
    return this.http.delete(`${this.apiUrl}/userAccounts`, {
      params: {
        userId: userId.toString(),
        accountId: accountId.toString(),
      },
    });
  }

  updateUserAccount(userId: number, accountId: number, disabled: boolean) {
    return this.http.put(
      `${this.apiUrl}/userAccounts`,
      { disabled: disabled },
      {
        params: { userId: userId.toString(), accountId: accountId.toString() },
      },
    );
  }

  getCurrentAccount(userId: number) {
    return this.http.get<UserAccount>(`${this.apiUrl}/currentAccount`, {
      params: {
        userId: userId.toString(),
      },
    });
  }

  setCurrentAccount(userId: number, accountId: number) {
    return this.http
      .put(`${this.apiUrl}/currentAccount`, null, {
        params: {
          userId: userId.toString(),
          accountId: accountId.toString(),
        },
      })
      .pipe(
        map(() => {
          return true;
        }),
      );
  }
}
